import { render, staticRenderFns } from "./listPreVenda.vue?vue&type=template&id=be2431a2"
import script from "./listPreVenda.ts?vue&type=script&lang=js&external"
export * from "./listPreVenda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2431a2')) {
      api.createRecord('be2431a2', component.options)
    } else {
      api.reload('be2431a2', component.options)
    }
    module.hot.accept("./listPreVenda.vue?vue&type=template&id=be2431a2", function () {
      api.rerender('be2431a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/listPreVenda.vue"
export default component.exports